import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { StickyCallBar } from "./StickyCallBar";

const DEFAULT_TITLE =
  "Missed-Call Text-Back for Contractors | Niagara Callback — Niagara Region & Hamilton";

export const LegalPage = ({ title, updated, sections, testId }) => {
  useEffect(() => {
    document.title = `${title} | Niagara Callback`;
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);

  return (
    <div className="bg-asphalt font-body text-white pb-16 sm:pb-0">
      <Header />
      <main className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-24" data-testid={testId}>
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-safety sm:text-sm">
          Last updated: {updated}
        </p>
        <h1 className="mt-4 font-display text-4xl font-bold uppercase leading-[1.05] tracking-tight sm:text-6xl">
          {title}
        </h1>
        {sections.map((section) => (
          <section key={section.heading} className="mt-12">
            <h2 className="border-b-2 border-line pb-3 font-display text-2xl font-bold uppercase tracking-tight text-safety sm:text-3xl">
              {section.heading}
            </h2>
            <div className="mt-5 space-y-4">
              {section.blocks.map((block, i) =>
                block.items ? (
                  <ul key={i} className="space-y-3">
                    {block.items.map((item) => (
                      <li
                        key={item}
                        className="flex gap-3 text-base leading-relaxed text-gray-300 sm:text-lg"
                      >
                        <span className="mt-2.5 h-2 w-2 shrink-0 rotate-45 bg-safety" aria-hidden="true" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p key={i} className="text-base leading-relaxed text-gray-300 sm:text-lg">
                    {block.lead && (
                      <strong className="font-semibold text-white">{block.lead} </strong>
                    )}
                    {block.text}
                    {block.link && (
                      <>
                        {" "}
                        <Link
                          to={block.link.href}
                          className="font-semibold text-safety underline underline-offset-4"
                        >
                          {block.link.text}
                        </Link>
                      </>
                    )}
                  </p>
                )
              )}
            </div>
          </section>
        ))}
      </main>
      <Footer />
      <StickyCallBar />
    </div>
  );
};
